import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import { RadioGroup } from '@/components/composite/Form/RadioGroup';
// Types
import { ReportFormBodyDataType } from '@/components/pages/reports/CreateEditPage/components/ReportForm/ReportFormBody';

type ControlledBooleanRadioGroupProps = {
    name: keyof ReportFormBodyDataType;
    label: string;
    tooltip?: string;
    disabled?: boolean;
    className?: string;
    isLocked?: boolean;
};

const ReportFormBodyControlledBooleanRadioGroup = ({
    name,
    label,
    tooltip,
    disabled,
    isLocked,
    className
}: ControlledBooleanRadioGroupProps) => {
    const { t } = useTranslation();
    const { control } = useFormContext<ReportFormBodyDataType>();
    return (
        <Controller
            control={control}
            name={name}
            rules={{
                required: true
            }}
            render={({ field: { onChange, value } }) => (
                <RadioGroup
                    className={className}
                    disabled={disabled}
                    tooltip={tooltip}
                    label={label}
                    isLocked={isLocked}
                    values={[
                        {
                            id: `${name}_yes`,
                            value: 1,
                            label: t('reports:create.value_yes'),
                            name: name
                        },
                        {
                            id: `${name}_no`,
                            value: 0,
                            label: t('reports:create.value_no'),
                            name: name
                        }
                    ]}
                    onChange={(e) => {
                        onChange(Number(e.target.value));
                    }}
                    current={isLocked ? 0 : value}
                />
            )}
        />
    );
};

export default ReportFormBodyControlledBooleanRadioGroup;
